import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const pillars = ['Método', 'Memoria', 'Organización', 'Orales', 'Ansiedad', 'Resultados'];
const tomos = [{
  n: 1,
  title: 'Autopsia del Fracaso Académico',
  desc: 'Por qué los métodos tradicionales (leer y resaltar) fallan en la facultad y cómo resetear tu mente para estudiar de forma completamente diferente desde hoy.'
}, {
  n: 2,
  title: 'Foco de Hierro en la Era de TikTok',
  desc: 'Cómo entrar en estado de "Deep Work" y eliminar distracciones digitales para estudiar el doble en la mitad del tiempo sin fuerza de voluntad.'
}, {
  n: 3,
  title: 'Lectura por Capas (Comprensión Veloz)',
  desc: 'El método para procesar textos universitarios densos sin tener que leerlos tres veces para entender de qué hablan realmente.'
}, {
  n: 4,
  title: 'Cartografía de Examen: Predecir al Docente',
  desc: 'Cómo analizar programas y clases para saber exactamente qué temas van a entrar en el parcial antes de que los tomen.'
}, {
  n: 5,
  title: 'Arquitectura de Apuntes Inteligentes',
  desc: 'Dejá de transcribir. Técnicas Cornell y Mapas para que tus apuntes sean el 80% del estudio realizado sin tener que releer todo.'
}, {
  n: 6,
  title: 'El Palacio de la Memoria Universitaria',
  desc: 'Técnicas de mnemotecnia avanzada para recordar fechas, fórmulas y conceptos complejos sin machetes ni repetición ciega.'
}, {
  n: 7,
  title: 'Protocolo Anti-Procrastinación 5-4-3-2-1',
  desc: 'El sistema psicológico para vencer la resistencia inicial y empezar a estudiar aunque no tengas ganas ni energía disponible.'
}, {
  n: 8,
  title: 'Oratoria y Dominio frente al Tribunal',
  desc: 'Cómo manejar el lenguaje corporal y la voz para proyectar seguridad en finales orales, aunque estés nervioso por dentro.'
}, {
  n: 9,
  title: 'Ingeniería de la Respuesta Escrita',
  desc: 'El arte de redactar parciales: cómo estructurar tus respuestas para que el docente sienta que está leyendo a un profesional.'
}, {
  n: 10,
  title: 'Gestión de Ansiedad y Pánico Académico',
  desc: 'Herramientas de control mental para evitar el bloqueo en blanco durante el momento exacto de rendir el examen.'
}, {
  n: 11,
  title: 'Cronograma Maestro de Cuatrimestre',
  desc: 'Cómo planificar tus semanas para estudiar, trabajar y tener vida social sin colapsar ni llegar tarde a ningún parcial o final.'
}, {
  n: 12,
  title: 'Resurrección: Del Bochazo al Aprobado',
  desc: 'El plan de acción para cuando desaprobás: cómo analizar el error, resetear la mentalidad y volver a rendir con éxito inmediato.'
}];
const includes = ['Técnicas listas para aplicar', 'Protocolos paso a paso', 'Plantillas editables', 'Ejemplos del mercado ARG', 'Checklists de implementación', 'Estrategias para trabajar y estudiar', 'Casos reales de universitarios', 'Listo para aplicar desde hoy'];
export function Tomos() {
  return <section aria-label="Los 12 tomos" className="bg-ink" data-id="element-184" data-mp="2xo1s12v4gnvu">
      <div className="mx-auto max-w-6xl px-5 py-20 pb-[28px] pt-[4px]" data-id="element-185" data-mp="2xlf9672s6lyb">
        <div className="text-center pt-[14px]" data-id="element-186" data-mp="3hamsev2rycdk">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold" data-id="element-187" data-mp="3lawx84etywqu">
            🏆 MegaPack Universitario Elite™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-white sm:text-4xl" data-id="element-188" data-mp="37a2qrrbcf5ut">
            12 Tomos + 5 Bonos
          </h2>
          <p className="mt-2 text-base text-white/60" data-id="element-189" data-mp="3ccblas3v6fz1">100+ páginas — Todo resuelto.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-190" data-mp="2xk1bnp0ywxs1">
            {pillars.map(p => <span key={p} className="rounded-full border border-gold/30 bg-gold/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-gold" data-id="element-191" data-mp="32cudo551xs0f">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-192" data-mp="2tjzbjkavscev">
          {tomos.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06
        }} className="group rounded-2xl border border-white/10 bg-ink-2 p-5 transition-colors duration-200 hover:border-verde/50" data-id="element-193" data-mp="2en8gfn88pmv2" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-194" data-mp="387kqdr6zw647">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-verde/20 font-display text-lg font-black text-verde-soft" data-id="element-195" data-mp="3871ear410by3">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-white" data-id="element-196" data-mp="2z98wngau0s7j">{t.title}</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-197" data-mp="2p8ow6fv4zrqd">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-gold/25 bg-ink-2 p-6" data-id="element-198" data-mp="sgopt8tekfcq">
          <p className="text-center font-display text-lg font-black text-gold" data-id="element-199" data-mp="nhlititv3z24">
            ✅ Cada tomo incluye
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-200" data-mp="uztgd5dj378e">
            {includes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-white/75" data-id="element-201" data-mp="zz64ruk1smd3">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-verde-soft" strokeWidth={3} data-id="element-202" data-mp="14q4mmykopsig" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}